import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import SituationGlyph from '../SituationGlyph';
import { tie } from '../page/typography';

/**
 * Картка ситуації. Натискається вся, але посилання — лише назва: раніше
 * всю картку обгортав <a>, і диктор читав як назву посилання назву, абзац
 * і підпис разом — понад двісті знаків. Тепер посилання розтягнуте на
 * картку псевдоелементом (after:inset-0), а читається коротко.
 *
 * Малюнок стоїть поруч із назвою, а не над нею: на телефоні так кожна
 * картка нижча на рядок, і шість ситуацій уміщаються в півтора екрана.
 *
 * Тінь — лише при наведенні, як у решти клікабельних карток сайту: у спокої
 * картки всюди однакові, рамка без тіні, і тінь сама каже «це натискається».
 */
const SituationCard = ({ situation, index }) => (
  <li className="group relative flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-5 lg:p-6 hover:border-teal-300 hover:shadow-md transition-[border-color,box-shadow] duration-200">
    <div className="flex items-center gap-4">
      <span className="flex-shrink-0 w-14 h-14 rounded-2xl bg-teal-50 text-teal-700 flex items-center justify-center" aria-hidden="true">
        <SituationGlyph index={index} className="w-9 h-9" />
      </span>
      <h3 className="text-lg font-bold font-display text-slate-900 leading-snug text-balance">
        <Link
          to={situation.to}
          className="after:absolute after:inset-0 after:rounded-2xl group-hover:text-teal-800 transition-colors duration-200 focus:outline-none focus-visible:after:ring-2 focus-visible:after:ring-teal-700 focus-visible:after:ring-offset-2"
        >
          {tie(situation.title)}
        </Link>
      </h3>
    </div>

    <p className="mt-4 text-slate-600 leading-relaxed">{tie(situation.text)}</p>

    {/* mt-auto: рядок «куди далі» в усіх картках ряду на одній лінії,
        хоч абзаци й різної довжини. */}
    <div className="mt-auto pt-5">
      <div className="flex items-center justify-between gap-4 border-t border-slate-100 pt-4">
        <span className="font-semibold text-teal-700 group-hover:text-teal-800 transition-colors duration-200">
          {situation.linkLabel}
        </span>
        <span
          className="flex-shrink-0 w-9 h-9 rounded-full bg-teal-50 text-teal-700 flex items-center justify-center group-hover:bg-teal-700 group-hover:text-white transition-colors duration-200"
          aria-hidden="true"
        >
          <Icon name="fa-arrow-right" className="text-sm" />
        </span>
      </div>
    </div>
  </li>
);

export default SituationCard;
